<template>
  <div>
    <div class="row align-items-center">
      <div class="col font-weight-bold">Playable Tasks</div>
      <div class="col text-right">
        <button
            type="button"
            class="btn btn-link font-weight-bold text-grey-02"
            style="padding-right: 0 !important;"
            @click="triggerAddNewTask"
        >
          <AddPlusIcon/>
          Add
        </button>
      </div>
    </div>

    <playable-task-item
        v-for="task in tasks"
        :key="`playable-${task.id}`"
        :task="task"
        @taskUpdated="updateTaskList"
        @taskDeleted="deleteFromTaskList"
        @saveLabel="saveLabel"
        @deleteLabel="deleteLabel"
    ></playable-task-item>

    <div class="mt-3">
      <input
          ref="add-task"
          class="form-control"
          :class="inputClass"
          @focus="addNewTodoTaskFocused = true"
          @keydown.enter="saveNewTask"
          @keydown.esc="cancel"
          placeholder="Add a new playable task"
          v-model="addNewTodoTaskTitle"
      />
      <div v-if="!disabledAddTask" class="row mt-2">
        <div class="col-12">
          <div
              class="d-flex justify-content-between align-items-center action-wrapper"
          >
            <div class="d-flex">
              <button
                  class="border-0 bg-transparent no-outline"
                  @click="updatingLabels = true"
              >
                <img
                    :src="'/images/tag.svg'"
                    style="width: 24px; height: 24px"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add-label-modal
        v-if="updatingLabels"
        :required="false"
        :options="labelOptions"
        :selected="selectedLabel"
        @selectItem="temporarilySaveTaskLabel"
        @deleteItem="deleteLabel"
        @updateLabel="updateLabel"
        @closeModal="updatingLabels = false"
    ></add-label-modal>
  </div>
</template>

<script>
import Task from '../Task';
import { store } from '../../../services/taskService';
import AddPlusIcon from '../../../icons/AddPlusIcon';

export default {
  name: 'PlayableTaskList',

  components: { AddPlusIcon },

  data () {
    return {
      taskService: Task,
      tasks: [],
      addNewTodoTaskFocused: false,
      addNewTodoTaskTitle: null,
      temporaryLabel: null,
      selectedLabel: null,
      updatingLabels: false,
    };
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser;
    },

    labelOptions () {
      return this.$store.state.labelOptions;
    },

    disabledAddTask () {
      return !(this.addNewTodoTaskFocused || this.addNewTodoTaskTitle);
    },

    inputClass () {
      return { 'bg-light': this.disabledAddTask, 'border-0': this.disabledAddTask };
    },
  },

  methods: {
    async fetchTasks () {
      const filters = {
        assigned_to: 'personal',
        type: 'playable',
        range: 'today',
        status: 'today',
        per_page: 200,
      };

      const data = await this.taskService.fetchTasks(filters);
      this.tasks = data.data;
    },

    updateTaskList (updatedTask) {
      this.tasks = this.tasks.map(task => {
        if (task.id === updatedTask.id) {
          Object.keys(updatedTask).forEach(key => {
            task[key] = updatedTask[key];
          });
        }

        return task;
      });
    },

    async saveNewTask () {
      const response = await store({ type: 'playable', title: this.addNewTodoTaskTitle }, {
        assignees: [this.currentUser.id],
        label_id: this.temporaryLabel,
      });

      this.resetFields();
      this.tasks.push(response.data.data);
    },

    cancel () {
      this.addNewTodoTaskFocused = false;
      this.resetFields();
      this.$nextTick(() => {
        this.$refs['add-task'].blur();
      });
    },

    resetFields () {
      this.addNewTodoTaskTitle = null;
    },

    triggerAddNewTask () {
      this.$refs['add-task'].focus();
      this.$refs['add-task'].scrollIntoView({ block: 'center', behavior: 'smooth' });
    },

    deleteFromTaskList (deletedTask) {
      this.tasks = this.tasks.filter(task => {
        return task.id !== deletedTask.id;
      });
    },

    async saveLabel (data) {
      const { label } = data;
      let found = false;

      this.$store.state.labelOptions = this.labelOptions.map(value => {
        if (value.id === label.id) {
          found = true;
          return label;
        }

        return value;
      });

      if (!found) {
        this.$store.state.labelOptions.push({
          ...label
        });
      }
    },

    async deleteLabel (labelId) {
      await axios.delete(`/company/${this.currentUser.company.id}/labels/${labelId}`);
      const newLabels = this.labelOptions.filter(value => {
        return value.id !== labelId;
      });

      this.$store.state.labelOptions = newLabels.map(value => {
        return value;
      });
    },

    temporarilySaveTaskLabel (value, labelId) {
      this.selectedLabel = value;
      this.temporaryLabel = labelId;
    },

    async updateLabel (val, labelId) {
      let label = null;

      if (labelId) {
        const res = await axios.patch(`/company/${this.currentUser.company.id}/labels/${labelId}`, { label: val });
        label = res.data.data;
      } else {
        const res = await axios.post(`/company/${this.currentUser.company.id}/labels`, { label: val });
        label = res.data.data;
      }

      await this.saveLabel({ val, label });
    },
  },

  mounted () {
    this.fetchTasks();
  },
};
</script>

<style scoped>

</style>
